import { render, staticRenderFns } from "./ChoosePermissionMulti.vue?vue&type=template&id=85d72732&scoped=true"
import script from "./ChoosePermissionMulti.vue?vue&type=script&lang=js"
export * from "./ChoosePermissionMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d72732",
  null
  
)

export default component.exports